import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataCommon } from 'src/app/master-data/master-data.common';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { DiaryReportService } from 'src/app/services/diary-report.service';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { EmployeeLeaveDetailModel, EmployeeLeaveTypeAndDate } from './emp-leave-detail.model';
import { EmployeeLeaveSummaryModel } from './emp-leave-summary.model';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-emp-leave-summary',
  templateUrl: './emp-leave-summary.component.html',
  styleUrls: ['./emp-leave-summary.component.css'],
})
export class EmpLeaveSummaryComponent implements OnInit {
  leaveForm;
  roleList;
  branchList;
  empList;
  financialYearList;
  formSubmitted = false;
  formErrors = MasterDataCommon.diaryDetailsFormErrors;
  formValidationMessages = MasterDataCommon.diaryDetailsFormValidationMessages;
  reportOutput: EmployeeLeaveSummaryModel;
  selectedFy;
  selectedBranch;
  selectedRole;
  selectedEmp;

  page = 1;
  pageSize = 1;

  isRoleSelected = false;
  isBranchSelected = false;
  isEmpSelected = false;
  userRole;
  accessResponse: any;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private diaryReportService: DiaryReportService,
    private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.selectedFy = "";
    this.loadFinancialYear();
    this.loadRoles();
    this.loadBranches();
  }

  onViewReport() {
    console.log('employee', this.selectedEmp);
    if (this.selectedFy == null || this.selectedFy == undefined || this.selectedFy == "" ||
      this.selectedEmp == null || this.selectedEmp == undefined || this.selectedEmp.length === 0 ||
      this.selectedBranch.length === 0 || this.selectedBranch == undefined ||
      this.selectedRole.length === 0 || this.selectedRole == undefined) {
      this.commonMessageService.swalAlertWithoutIcon('', "Please choose the values before pressing report");
      return;
    } else {
      this.loadReport(this.selectedEmp[0]);
    }
  }

  loadReport(user) {
    let fyId = this.selectedFy.id;
    if (user != null && user != undefined && user != "") {
      this.masterDataService.getLeaveSummary(fyId, user.id).subscribe((res) => {
        this.reportOutput = res;
        this.showExportToExcelButton = true;
        this.cleanReportOutput();
        console.log('report length', this.reportOutput);
      });
    }
  }
  cleanReportOutput() {
    for (let i = 0; i < this.reportOutput.leaveDetails.length; i++) {
      if (this.reportOutput.leaveDetails[i].leaveTypeAndDate.length == 0) {
        let leaveType = new EmployeeLeaveTypeAndDate();
        this.reportOutput.leaveDetails[i].leaveTypeAndDate.push(leaveType);
      }
    }
  }
  loadPage(page: number) {
    page--;
    this.loadReport(this.selectedEmp[page]);
  }

  getRoleAndBranch() {
    setTimeout(() => {
      if (
        this.selectedRole != null &&
        this.selectedRole != undefined &&
        this.selectedRole.length > 0 &&
        this.selectedBranch != null &&
        this.selectedBranch != undefined &&
        this.selectedBranch.length > 0
      ) {

        this.diaryReportService
          .getEmpByBranchRole(this.selectedBranch, this.selectedRole)
          .subscribe((res) => {
            this.empList = res;
          });
      } else {
        this.empList = [];
        this.selectedEmp = [];
      }
    }, 500);
  }

  loadFinancialYear() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialYearList = res;
    });
  }
  loadRoles() {
    this.masterDataService.getRoles().subscribe((res) => {
      this.roleList = res;
    });
  }
  loadBranches() {
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }
  
  loadLookupForManageProfile() {
    this.humanResourceService
      .getLookupForManageProfile()
      .subscribe((res: any) => {
        this.roleList = res.roles;
        this.branchList = res.branches;
      });
  }

  selectAllRole(select: NgModel, values) {
    this.selectAll(select, values, this.isRoleSelected, true);
    this.isRoleSelected = !this.isRoleSelected;
  }
  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, true);
    this.isBranchSelected = !this.isBranchSelected;
  }
  selectAllEmp(select: NgModel, values) {
    this.selectAll(select, values, this.isEmpSelected, false);
    this.isEmpSelected = !this.isEmpSelected;
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    let ids = [];
    if (!isSelected) {
      if (isId) {
        for (let i = 0; i < values.length; i++) {
          ids.push(values[i].id);
        }
        select.update.emit(ids);
      } else select.update.emit(values);
    } else select.update.emit([]);
  }

  showExportToExcelButton = false;
  exportToExcelClick() {
    const empId = this.selectedEmp.map(({ id }) => id);
    console.log('select employee', empId);

    this.masterDataService.employeeLeaveReportExportToExcel(this.selectedFy.id, empId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "EmployeeLeaveSummary.xlsx";
      link.click();
    })
  }
}
